import { actionGenerator } from 'shared/utils/redux/actionGenerator';

import { ECpdDraftStatus } from '../../types/cpd/cpd';

export enum ECPDActionTypes {
  setAvailableCpd = 'cpd/setAvailableCpd',
  setCpdDraftId = 'cpd/setCpdDraftId',
  setCpdDraftStatus = 'cpd/setCpdDraftStatus',
}

export const setAvailableCpd = actionGenerator<ECPDActionTypes.setAvailableCpd, boolean>(
  ECPDActionTypes.setAvailableCpd,
);
export const setCpdDraftId = actionGenerator<ECPDActionTypes.setCpdDraftId, number>(ECPDActionTypes.setCpdDraftId);
export const setCpdDraftStatus = actionGenerator<ECPDActionTypes.setCpdDraftStatus, ECpdDraftStatus>(
  ECPDActionTypes.setCpdDraftStatus,
);

export type TCPDActions =
  | ReturnType<typeof setAvailableCpd>
  | ReturnType<typeof setCpdDraftId>
  | ReturnType<typeof setCpdDraftStatus>;
